import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import banner from '../images/banner3.png'

const cards = [
  { number: '01', title: 'Comprehensive Information', description: 'We provide detailed insights into the best Pre-University colleges in Bangalore, helping students make informed decisions' },
  { number: '02', title: 'Expert Guidance', description: 'Our platform offers curated advice and recommendations to match student preferences and career goals' },
  { number: '03', title: 'User-Friendly Interface', description: 'Easily compare colleges based on facilities, courses, faculty, and extracurricular activities.' },
  { number: '04', title: 'Time-Saving', description: 'Skip lengthy searches; find everything you need in one place' },
];

const WhyChooseUs = () => {
  return (
    <Box sx={{ position: 'relative', mb: 0 }}>
      <Grid
        container
        spacing={{ xs: 2, sm: 3, md: 4 }}
        sx={{
          backgroundImage: `url(${banner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          padding: { xs: 4, sm: 8 },
          textAlign: 'center',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0, right: 0, bottom: 0, left: 0,
            background: 'linear-gradient(135deg, rgba(26,35,126,0.9) 0%, rgba(0,0,81,0.85) 100%)',
            zIndex: 1
          }
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 2, width: '100%' }}>
          <Grid item xs={12}>
            <motion.div initial={{ opacity: 0, y: -20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <Typography
                variant="h3"
                sx={{
                  color: 'white',
                  fontWeight: 800,
                  marginBottom: { xs: 4, sm: 6 },
                  fontSize: { xs: '32px', sm: '42px' },
                }}
              >
                Why Choose Us
              </Typography>
            </motion.div>
          </Grid>
          <Grid container spacing={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            {cards.map((card, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.15, duration: 0.5 }}
                >
                  <Box
                    className="glass-card"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      background: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      borderRadius: '20px',
                      padding: { xs: 3, sm: 4 },
                      height: '100%',
                      minHeight: '260px',
                      position: 'relative',
                      overflow: 'hidden',
                      color: 'white',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        background: 'rgba(255, 255, 255, 0.15)',
                        borderColor: 'var(--secondary-color)'
                      }
                    }}
                  >
                    {/* Ghost Number inside card */}
                    <Typography sx={{
                      position: 'absolute', top: -10, right: 10, fontSize: '80px',
                      fontWeight: 900, opacity: 0.1, color: '#fff', fontStyle: 'italic', zIndex: -1
                    }}>
                      {card.number}
                    </Typography>

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: { xs: 2, sm: 3 },
                        borderBottom: '2px solid var(--secondary-color)',
                        pb: 1
                      }}
                    >
                      <Typography sx={{ fontSize: { xs: '20px', sm: '22px' }, fontWeight: 700, lineHeight: 1.3 }}>
                        {card.title}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'rgba(255,255,255,0.85)',
                        fontSize: { xs: '15px', sm: '16px' },
                        lineHeight: 1.6
                      }}
                    >
                      {card.description}
                    </Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default WhyChooseUs;
